import { FormBuilder } from "components/FormBuilder/FormBuilder";
import React from 'react'
import { useTranslation } from "react-i18next";

/**
 * @param {Object} props 
 * @param {import("react-hook-form").UseFormReturn} props.formProps
 * @param {boolean} props.isCreate
 * @param {boolean} props.isEditing
 * @param {boolean} props.isLoading
 */
const OnlineMerchantManagementProcessorEnableSection = ({
  formProps,
  isCreate,
  isEditing,
  isLoading
}) => {
  const { t: tLocal } = useTranslation("translation", { keyPrefix: "form.onlineMerchantManagement.merchant.processorEnableSection" });
  const { t: tCommon } = useTranslation();

  const isDisabled = isLoading;
  const isReadOnly = !isCreate && !isEditing;

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    cardEnable: {
      fieldType: "checkbox",
      fieldName: "cardEnable",
      label: tLocal("label.cardEnable"),
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        defaultValue: true
      }
    },
    alihkEnable: {
      fieldType: "checkbox",
      fieldName: "alihkEnable",
      label: tLocal("label.alihkEnable"),
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        defaultValue: true
      }
    },
    alicnEnable: {
      fieldType: "checkbox",
      fieldName: "alicnEnable",
      label: tLocal("label.alicnEnable"),
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        defaultValue: true
      }
    },
    wechatEnable: {
      fieldType: "checkbox",
      fieldName: "wechatEnable",
      label: tLocal("label.wechatEnable"),
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        defaultValue: true
      }
    },
    applePayEnable: {
      fieldType: "checkbox",
      fieldName: "applePayEnable",
      label: tLocal("label.applePayEnable"),
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        defaultValue: true
      }
    },
    googlePayEnable: {
      fieldType: "checkbox",
      fieldName: "googlePayEnable",
      label: tLocal("label.googlePayEnable"),
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        defaultValue: true
      }
    },
    upiEnable: {
      fieldType: "checkbox",
      fieldName: "upiEnable",
      label: tLocal("label.upiEnable"),
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        defaultValue: true
      }
    }
  }

  return (
    <FormBuilder.Section
      title={tLocal("title")}
      titleVariant="h3"
    >
      <FormBuilder.Row itemsPerRow={4}>
        {FormBuilder.buildFields({
          formProps,
          t: tCommon,
          fields: Object.values(fieldsConfig)
        })}
      </FormBuilder.Row>
    </FormBuilder.Section>
  )
}

export default OnlineMerchantManagementProcessorEnableSection